import { render, staticRenderFns } from "./PaymentResponse.vue?vue&type=template&id=6314e25e&scoped=true"
import script from "./PaymentResponse.vue?vue&type=script&lang=js"
export * from "./PaymentResponse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6314e25e",
  null
  
)

export default component.exports